import React from 'react';

export const sectionHeaderStyle: React.CSSProperties = {
  fontSize: '12px',
  textTransform: 'uppercase',
  color: '#888',
  marginBottom: '10px',
  marginTop: '20px',
  fontWeight: 'bold',
  letterSpacing: '1px'
};

export const buttonStyle: React.CSSProperties = {
  display: 'block',
  width: '100%',
  padding: '8px 12px',
  marginBottom: '8px',
  background: 'rgba(255, 255, 255, 0.05)',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'rgba(255, 255, 255, 0.1)',
  borderRadius: '4px',
  color: '#ecf0f1',
  cursor: 'pointer',
  textAlign: 'left',
  fontSize: '13px',
  transition: 'all 0.2s'
};

export const inputStyle: React.CSSProperties = {
  width: '100%',
  padding: '6px',
  marginBottom: '8px',
  background: 'rgba(0, 0, 0, 0.3)',
  border: '1px solid rgba(255, 255, 255, 0.1)',
  borderRadius: '4px',
  color: 'white',
  fontSize: '12px'
};

export const labelStyle: React.CSSProperties = {
  display: 'block',
  fontSize: '11px',
  color: '#aaa',
  marginBottom: '4px'
};
